import { Component, Input, OnInit } from '@angular/core';
import {
  UIKitIconRegistry,
  plusIcon,
  extLinkIcon,
  sheetIcon,
  profileIcon,
  coinsIcon,
  brokerIcon,
} from '@ui-kit';
import { UIKitIconName } from '@ui-kit/icon/icon';

@Component({
  selector: 'app-content-card',
  templateUrl: './content-card.component.html',
  styleUrls: ['./content-card.component.scss'],
})
export class ContentCardComponent implements OnInit {
  @Input() title: string;

  @Input() titleDetails: string;

  @Input() subtitle: string;

  @Input() badge: string;

  @Input() icon: Partial<UIKitIconName>;

  constructor(
    iconRegistry: UIKitIconRegistry,
  ) {
    iconRegistry.registerIcons([
      plusIcon,
      extLinkIcon,
      sheetIcon,
      profileIcon,
      coinsIcon,
      brokerIcon,
    ]);
  }

  ngOnInit(): void {}
}
